import { jsx as _jsx } from "react/jsx-runtime";
import AtLineIcon from 'remixicon-react/AtLineIcon';
import AttachmentLineIcon from 'remixicon-react/AttachmentLineIcon';
import CodeBoxLineIcon from 'remixicon-react/CodeBoxLineIcon';
import DoubleQuotesLIcon from 'remixicon-react/DoubleQuotesLIcon';
import EmotionLineIcon from 'remixicon-react/EmotionLineIcon';
import H1Icon from 'remixicon-react/H1Icon';
import H2Icon from 'remixicon-react/H2Icon';
import Image2LineIcon from 'remixicon-react/Image2LineIcon';
import LinkIcon from 'remixicon-react/LinkIcon';
import ListOrderedIcon from 'remixicon-react/ListOrderedIcon';
import ListUnorderedIcon from 'remixicon-react/ListUnorderedIcon';
import PlayCircleLineIcon from 'remixicon-react/PlayCircleLineIcon';
import SafariLineIcon from 'remixicon-react/SafariLineIcon';
import VideoLineIcon from 'remixicon-react/VideoLineIcon';
import { Youtube, Twitter, GoogleDrive, Figma, Giphy } from './icons';
export var MenuTypes;
(function (MenuTypes) {
    MenuTypes["BulletList"] = "bulletList";
    MenuTypes["Blockquote"] = "blockquote";
    MenuTypes["NumberedList"] = "numberedList";
    MenuTypes["LargeHeader"] = "largeHeader";
    MenuTypes["MediumHeader"] = "mediumHeader";
    MenuTypes["Image"] = "image";
    MenuTypes["Attachment"] = "attachment";
    MenuTypes["Emoji"] = "emoji";
    MenuTypes["Mention"] = "mention";
    MenuTypes["Embed"] = "embed";
    MenuTypes["Link"] = "link";
    MenuTypes["CodeBlock"] = "codeBlock";
    MenuTypes["Video"] = "video";
    MenuTypes["Audio"] = "audio";
    MenuTypes["Giphy"] = "giphy";
})(MenuTypes || (MenuTypes = {}));
export const slashMenuItemsFactory = (intl) => (extensions) => {
    const items = [];
    const { $t } = intl;
    if (extensions.heading) {
        items.push({
            type: MenuTypes.LargeHeader,
            label: $t({
                id: 'Composer.LargeHeader',
                defaultMessage: 'Large Header',
            }),
            icon: _jsx(H1Icon, {}, void 0),
        }, {
            type: MenuTypes.MediumHeader,
            label: $t({
                id: 'Composer.MediumHeader',
                defaultMessage: 'Medium Header',
            }),
            icon: _jsx(H2Icon, {}, void 0),
        });
    }
    items.push({
        type: MenuTypes.Blockquote,
        label: $t({
            id: 'Composer.Blockquote',
            defaultMessage: 'Blockquote',
        }),
        icon: _jsx(DoubleQuotesLIcon, {}, void 0),
    }, {
        type: MenuTypes.BulletList,
        label: $t({
            id: 'Composer.SlashMenu.BulletedLIst',
            defaultMessage: 'Bulleted List',
        }),
        icon: _jsx(ListUnorderedIcon, {}, void 0),
    }, {
        type: MenuTypes.NumberedList,
        label: $t({
            id: 'Composer.SlashMenu.NumberedList',
            defaultMessage: 'Numbered List',
        }),
        icon: _jsx(ListOrderedIcon, {}, void 0),
    });
    if (extensions.code) {
        items.push({
            type: MenuTypes.CodeBlock,
            label: $t({
                id: 'Composer.CodeBlock',
                defaultMessage: 'Code Block',
            }),
            icon: _jsx(CodeBoxLineIcon, {}, void 0),
        });
    }
    items.push({
        type: 'divider',
    }, {
        type: MenuTypes.Link,
        label: $t({
            id: 'Generics.Link.Noun',
            defaultMessage: 'Link',
        }),
        icon: _jsx(LinkIcon, {}, void 0),
    });
    if (extensions.mention) {
        items.push({
            type: MenuTypes.Mention,
            label: $t({
                id: 'Composer.SlashMenu.Mention',
                defaultMessage: 'Mention',
            }),
            icon: _jsx(AtLineIcon, {}, void 0),
        });
    }
    if (extensions.emoji) {
        items.push({
            type: MenuTypes.Emoji,
            label: $t({
                id: 'Generics.Emoji',
                defaultMessage: 'Emoji',
            }),
            icon: _jsx(EmotionLineIcon, {}, void 0),
        });
    }
    items.push({
        type: 'divider',
    });
    if (extensions.attachment) {
        items.push({
            type: MenuTypes.Attachment,
            label: $t({
                id: 'Composer.SlashMenu.Attachment',
                defaultMessage: 'Attachment',
            }),
            icon: _jsx(AttachmentLineIcon, {}, void 0),
        });
    }
    if (extensions.image) {
        items.push({
            type: MenuTypes.Image,
            label: $t({
                id: 'Composer.SlashMenu.Image',
                defaultMessage: 'Image',
            }),
            icon: _jsx(Image2LineIcon, {}, void 0),
        });
    }
    if (extensions.video) {
        items.push({
            type: MenuTypes.Video,
            label: $t({
                id: 'Composer.SlashMenu.Video',
                defaultMessage: 'Video',
            }),
            icon: _jsx(VideoLineIcon, {}, void 0),
        }, {
            type: MenuTypes.Audio,
            label: $t({
                id: 'Composer.SlashMenu.Audio',
                defaultMessage: 'Audio',
            }),
            icon: _jsx(PlayCircleLineIcon, {}, void 0),
        });
    }
    if (extensions.embed) {
        items.push({
            type: MenuTypes.Embed,
            label: $t({
                id: 'Generics.Embed',
                defaultMessage: 'Embed',
            }),
            icon: _jsx(SafariLineIcon, {}, void 0),
        }, {
            type: 'divider',
        });
        if (extensions.image) {
            items.push({
                type: MenuTypes.Giphy,
                label: 'Giphy',
                icon: _jsx(Giphy, {}, void 0),
            });
        }
        items.push({
            type: MenuTypes.Embed,
            description: $t({
                id: 'Composer.SlashMenu.YoutubeEmbedDescription',
                defaultMessage: 'Embed a Youtube Video.',
            }),
            label: $t({
                id: 'Composer.SlashMenu.Youtube',
                defaultMessage: 'Youtube',
            }),
            icon: _jsx(Youtube, {}, void 0),
        }, {
            type: MenuTypes.Embed,
            description: $t({
                id: 'Composer.SlashMenu.TwitterEmbedDescription',
                defaultMessage: 'Embed a Tweet.',
            }),
            label: $t({
                id: 'Composer.SlashMenu.Twitter',
                defaultMessage: 'Twitter',
            }),
            icon: _jsx(Twitter, {}, void 0),
        }, {
            type: MenuTypes.Embed,
            description: $t({
                id: 'Composer.SlashMenu.GoogleDriveEmbedDescription',
                defaultMessage: 'Embed a Google Doc, Google Sheet...',
            }),
            label: $t({
                id: 'Composer.SlashMenu.GoogleDrive',
                defaultMessage: 'Google Drive',
            }),
            icon: _jsx(GoogleDrive, {}, void 0),
        }, {
            type: MenuTypes.Embed,
            description: $t({
                id: 'Composer.SlashMenu.FigmaEmbedDescription',
                defaultMessage: 'Embed a Figma file.',
            }),
            label: $t({
                id: 'Composer.SlashMenu.Figma',
                defaultMessage: 'Figma',
            }),
            icon: _jsx(Figma, {}, void 0),
        });
    }
    return items;
};
//# sourceMappingURL=items.js.map